import { render, staticRenderFns } from "./BudgetPlaceCard.vue?vue&type=template&id=2e9933c5"
import script from "./BudgetPlaceCard.vue?vue&type=script&lang=ts"
export * from "./BudgetPlaceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports